import React, { useMemo } from 'react'
import { subscribe } from 'react-contextual'
import { Heading, InfoList, Header } from 'components'
import EditIcon from '../../../../../views/components/atoms/Svgs/Edit'
import PortfoliosProvider from '../../../PortfoliosProvider'
import { ContactsProvider } from 'modules/contacts'
import styles from './PropertyInfo.module.scss'

interface PropertyInfoProps {
  viewData: any
  openContactFromNonContactsRoute: (contactId: string) => void
  openEditProperty: (propertyId: string) => void
}

const PropertyInfo = ({ viewData, openContactFromNonContactsRoute, openEditProperty }: PropertyInfoProps) => {
  const { owner } = viewData

  const infoListItem = useMemo(
    () => [
      {
        label: 'Name',
        value: owner.name,
        onClick: () => owner?.ownerId && openContactFromNonContactsRoute(owner.ownerId),
      },
      {
        label: 'Email',
        value: owner.email,
        mailTo: true,
        copyToClipboard: true,
      },
      {
        label: 'Number',
        value: owner.contactNumber,
      },
      {
        label: 'ID',
        value: owner.idNumber,
        isVisible: owner.idNumber,
      },
      {
        label: 'Passport',
        value: owner.passportNumber,
        isVisible: owner.passportNumber,
      },
      {
        label: 'Reg',
        value: owner.companyRegistration,
        isVisible: owner.companyRegistration,
      },
    ],
    [owner],
  )

  const bankAccountItems = useMemo(
    () => [
      {
        label: 'Bank',
        value: owner.bank,
      },
      {
        label: 'Account',
        value: owner.accountNumber,
      },
    ],
    [owner],
  )

  return (
    <div className={styles.root}>
      <header>
        <button className={styles.edit} onClick={() => openEditProperty(viewData.propertyId)}>
          <EditIcon />
        </button>
        <div>
          <Heading as="h4" className={styles['meta-data']}>
            {viewData.metaData}
          </Heading>
          <Heading as="h2" className={styles.title}>
            {viewData.title}
          </Heading>
          <Heading as="h3" className={styles['sub-title']}>
            {viewData.subTitle}
          </Heading>
        </div>
      </header>
      <section>
        <Header className={styles.header} tag="h4" text="Owner details" />
        <InfoList items={infoListItem} />
      </section>
      <section>
        <Header className={styles.header} tag="h4" text="Bank account" />
        <InfoList spacing="none" items={bankAccountItems} />
      </section>
    </div>
  )
}

export default subscribe(
  [PortfoliosProvider, ContactsProvider],
  ({ openEditProperty }: any, { openContactFromNonContactsRoute }) => ({
    openEditProperty,
    openContactFromNonContactsRoute,
  }),
)(PropertyInfo)
